import {
  faBagShopping,
  faBolt,
  faCartShopping, faChartPie, faFileShield, faGear, faHouse, faIndustry, faSackDollar, faTags, faWarehouse,
} from '@fortawesome/free-solid-svg-icons';
import Helpers from './helpers';
import documentUINamesConstant from './documentUINamesConstant';

export const iconLibrary = {
  FONT_AWESOME_ICON: 'FONT_AWESOME_ICON',
  ANTD_ICON: 'ANTD_ICON',
};

export const userMenuConstant = (user) => {
  const enabledInventoryFeatures = user?.tenant_info?.inventory_config;
  const enabledPurchaseFeatures = user?.tenant_info?.purchase_config;
  const enabledSalesFeatures = user?.tenant_info?.sales_config;
  const enabledProductionFeatures = user?.tenant_info?.production_config;
  const enabledQualityControlFeatures = user?.tenant_info?.quality_control_config;
  const enabledWarehouseLocations = user?.tenant_info?.inventory_config?.settings?.enable_location_based_stock;
  const enabledLogisticsFeatures = user?.tenant_info?.logistics_config;

  const documentUINames = documentUINamesConstant(user);

  const menuChildren = {
    MANAGE_PRODUCT: {
      entity_type: 'MANAGE_PRODUCT',
      permission_entity: [
        Helpers.permissionEntities.PRODUCT,
      ],
      key: '/inventory/manage',
      label: 'Manage Products',
      // children: {},
      is_premium: !enabledInventoryFeatures?.sub_modules?.product?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    INVENTORY_TRACKING: {
      entity_type: 'INVENTORY_TRACKING',
      permission_entity: [
        Helpers.permissionEntities.INVENTORY_INDENT,
      ],
      key: '/inventory/tracking',
      label: 'Inventory Tracking',
      // children: {},
      is_premium: !enabledInventoryFeatures?.sub_modules?.product?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    STOCK_ADJUSTMENT: {
      entity_type: 'STOCK_ADJUSTMENT',
      permission_entity: [
        Helpers.permissionEntities.INVENTORY_INDENT,
      ],
      key: '/inventory/indent',
      label: 'Stock Adjustment',
      // children: {},
      is_premium: !enabledInventoryFeatures?.sub_modules?.stock_adjustment?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    STOCK_TRANSFER: {
      entity_type: 'STOCK_TRANSFER',
      permission_entity: [
        Helpers.permissionEntities.STOCK_TRANSFER,
      ],
      key: '/inventory/stock-transfer',
      label: 'Stock Transfer',
      // children: {},
      is_premium: !enabledInventoryFeatures?.sub_modules?.stock_transfer?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    DELIVERY_CHALLAN: {
      entity_type: 'DELIVERY_CHALLAN',
      permission_entity: [
        Helpers.permissionEntities.DELIVERY_CHALLAN,
      ],
      key: '/inventory/delivery-challan',
      label: 'Delivery Challan',
      // children: {},
      is_premium: !enabledInventoryFeatures?.sub_modules?.delivery_challan?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    GATE_DOCUMENT: {
      entity_type: 'GATE_DOCUMENT',
      permission_entity: [
        Helpers.permissionEntities.GATE_DOCUMENT,
      ],
      key: '/logistic/gate-document',
      label: 'Gate Document',
      // children: {},
      is_premium: !enabledLogisticsFeatures?.sub_modules?.gate_document?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    VENDORS: {
      entity_type: 'VENDORS',
      permission_entity: [
        Helpers.permissionEntities.VENDORS,
      ],
      key: '/purchase/vendors/manage',
      label: 'Vendors',
      // children: {},
      is_premium: !enabledPurchaseFeatures?.sub_modules?.vendor?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    PURCHASE_REQUEST: {
      entity_type: 'PURCHASE_REQUEST',
      permission_entity: [
        Helpers.permissionEntities.PURCHASE_REQUEST,
      ],
      key: '/purchase/purchase-request',
      label: 'Material Requests',
      // children: {},
      is_premium: !enabledPurchaseFeatures?.sub_modules?.purchase_request?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    PURCHASE_INDENT: {
      entity_type: 'PURCHASE_INDENT',
      permission_entity: [
        Helpers.permissionEntities.PURCHASE_INDENT,
      ],
      key: '/purchase/purchase-indent',
      label: 'Purchase Indent',
      is_premium: !enabledPurchaseFeatures?.sub_modules?.purchase_indent?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    REQUEST_FOR_QUOTATION: {
      entity_type: 'REQUEST_FOR_QUOTATION',
      permission_entity: [
        Helpers.permissionEntities.REQUEST_FOR_QUOTATION,
      ],
      key: '/purchase/rfq',
      label: 'Request for Quotation',
      // children: {},
      is_premium: !enabledPurchaseFeatures?.addons?.request_for_quotation?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    PURCHASE_ORDER: {
      entity_type: 'PURCHASE_ORDER',
      permission_entity: [
        Helpers.permissionEntities.PURCHASE_ORDER,
      ],
      key: '/purchase/purchase-orders',
      label: 'Purchase Orders',
      // children: {},
      is_premium: !enabledPurchaseFeatures?.sub_modules?.purchase_order?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    GOOD_RECEIVING: {
      entity_type: 'GOOD_RECEIVING',
      permission_entity: [
        Helpers.permissionEntities.GOOD_RECEIVING,
      ],
      key: '/purchase/goods-receiving',
      label: 'Goods Receiving',
      // children: {},
      is_premium: !enabledPurchaseFeatures?.sub_modules?.goods_receiving_note?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    ACCOUNT_PAYABLE_INVOICE: {
      entity_type: 'ACCOUNT_PAYABLE_INVOICE',
      permission_entity: [
        Helpers.permissionEntities.ACCOUNT_PAYABLE_INVOICE,
      ],
      key: '/purchase/account-payable-invoice',
      label: 'Account Payable Invoice',
      // children: {},
      is_premium: !enabledPurchaseFeatures?.sub_modules?.account_payable_invoice?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    DEBIT_NOTE: {
      entity_type: 'DEBIT_NOTE',
      permission_entity: [
        Helpers.permissionEntities.DEBIT_NOTE,
      ],
      key: '/purchase/debit-notes',
      label: 'Debit Notes',
      // children: {},
      is_premium: !enabledPurchaseFeatures?.sub_modules?.debit_note?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    EXPENSES: {
      entity_type: 'EXPENSES',
      permission_entity: [
        Helpers.permissionEntities.EXPENSES,
      ],
      key: '/purchase/expense',
      label: 'Expenses',
      // children: {},
      is_premium: !enabledPurchaseFeatures?.addons?.expense?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    BOM: {
      entity_type: 'BOM',
      permission_entity: [
        Helpers.permissionEntities.BOM,
      ],
      key: '/production/bom',
      label: 'Bill of Materials',
      // children: {},
      is_premium: !enabledProductionFeatures?.sub_modules?.bill_of_material?.is_active,
      isVisible: {
        onMobile: true,
      },

    },
    MANUFACTURING_ORDER: {
      entity_type: 'MANUFACTURING_ORDER',
      permission_entity: [
        Helpers.permissionEntities.MO,
      ],
      key: '/production/manufacturing-orders',
      label: 'Manufacturing Orders',
      // children: {},
      is_premium: !enabledProductionFeatures?.sub_modules?.manufacturing_order?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    SCHEDULES: {
      entity_type: 'SCHEDULES',
      permission_entity: [
        Helpers.permissionEntities.PRODUCTION_SCHEDULING,
      ],
      key: '/production/schedules',
      label: 'Schedules',
      // children: {},
      is_premium: !enabledProductionFeatures?.sub_modules?.scheduling?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    MANUAL_ENTRY: {
      entity_type: 'MANUAL_ENTRY',
      permission_entity: [
      ],
      key: '/production/manual-entry',
      label: 'Manual Entry',
      // children: {},
      is_premium: !enabledProductionFeatures?.sub_modules?.manual_production_entry?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    JOB_CARD: {
      entity_type: 'JOB_CARD',
      permission_entity: [
        Helpers.permissionEntities.FACTORY_SETUP,
      ],
      key: '/production/job-works',
      label: 'Job Cards',
      // children: {},
      is_premium: !enabledProductionFeatures?.addons?.job_card?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    MRP: {
      entity_type: 'MRP',
      permission_entity: [
        Helpers.permissionEntities.MRP,
      ],
      key: '/production/planning/v2',
      label: 'Materials Planning',
      // children: {},
      is_premium: !enabledProductionFeatures?.addons?.material_planing?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    FACTORY_SETUP: {
      entity_type: 'FACTORY_SETUP',
      permission_entity: [
        Helpers.permissionEntities.FACTORY_SETUP,
      ],
      key: '/production/configurations',
      label: 'Factory Setup',
      // children: {},
      is_premium: !enabledProductionFeatures?.addons?.factory_setup?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    QUALITY_RULES: {
      entity_type: 'QUALITY_RULES',
      permission_entity: [
        Helpers.permissionEntities.QUALITY_RULES,
      ],
      key: '/quality/quality-control-points',
      label: 'Quality Rules',
      // children: {},
      is_premium: !enabledQualityControlFeatures?.sub_modules?.quality_control_rule?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    IN_PROCESS_QUALITY_CONTROL_RULE: {
      entity_type: 'IN_PROCESS_QUALITY_CONTROL_RULE',
      permission_entity: [
        Helpers.permissionEntities.IN_PROCESS_QUALITY_CONTROL_RULE,
      ],
      key: '/quality/quality-control-points',
      label: 'In Process Quality Rules',
      // children: {},
      is_premium: !enabledQualityControlFeatures?.sub_modules?.in_process_quality_control_rule?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    QUALITY_CHECKS: {
      entity_type: 'QUALITY_CHECKS',
      permission_entity: [
        Helpers.permissionEntities.QUALITY_CHECKS,
      ],
      key: '/quality/quality-checks',
      label: 'Quality Checks',
      // children: {},
      is_premium: !enabledQualityControlFeatures?.sub_modules?.quality_check?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    IN_PROCESS_QUALITY_CHECK: {
      entity_type: 'IN_PROCESS_QUALITY_CHECK',
      permission_entity: [
        Helpers.permissionEntities.IN_PROCESS_QUALITY_CHECK,
      ],
      key: '/quality/inprocess-quality-checks',
      label: 'In Process Quality Checks',
      // children: {},
      is_premium: !enabledQualityControlFeatures?.sub_modules?.in_process_quality_check?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    PRE_DISPATCH_INSPECTION_CHECK: {
      entity_type: 'PRE_DISPATCH_INSPECTION_CHECK',
      permission_entity: [
        Helpers.permissionEntities.PDI_CHECK,
      ],
      key: '/quality/pre_dispatch_inspection_check',
      label: 'Pre Dispatch Inspection Check',
      // children: {},
      is_premium: !enabledQualityControlFeatures?.sub_modules?.pre_dispatch_inspection_check?.is_active,
      isVisible: {
        onMobile: false,
      },
    },
    PRE_DISPATCH_INSPECTION_RESULT: {
      entity_type: 'PRE_DISPATCH_INSPECTION_RESULT',
      permission_entity: [
        Helpers.permissionEntities.PDI_CHECK,
      ],
      key: '/quality/pre_dispatch_inspection_check',
      label: 'Pre Dispatch Inspection Result',
      // children: {},
      is_premium: !enabledQualityControlFeatures?.sub_modules?.pre_dispatch_inspection_check?.is_active,
      isVisible: {
        onMobile: false,
      },
    },
    CUSTOMER: {
      entity_type: 'CUSTOMER',
      permission_entity: [
        Helpers.permissionEntities.CUSTOMER,
      ],
      key: '/sales/customers',
      label: 'Customers',
      // children: {},
      is_premium: !enabledSalesFeatures?.sub_modules?.customer?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    ESTIMATE: {
      entity_type: 'ESTIMATE',
      permission_entity: [
        Helpers.permissionEntities.SALES_ESTIMATE,
      ],
      key: '/sales/estimate',
      label: `${documentUINames?.estimateUIName || 'Estimate'}s`,
      // children: {},
      is_premium: !enabledSalesFeatures?.sub_modules?.sales_estimate?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    SALES_ORDER: {
      entity_type: 'SALES_ORDER',
      permission_entity: [
        Helpers.permissionEntities.SALES_ORDER,
      ],
      key: '/sales/sales-orders',
      label: `${documentUINames?.salesOrderUIName || 'Sales Order'}s`,
      // children: {},
      is_premium: !enabledSalesFeatures?.sub_modules?.sales_order?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    PACKING_SLIP: {
      entity_type: 'PACKING_SLIP',
      permission_entity: [
        Helpers.permissionEntities.PACKING_SLIP,
      ],
      key: '/sales/packing-slips',
      label: 'Packing Slip',
      // children: {},
      is_premium: !enabledSalesFeatures?.sub_modules?.packing_slip?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    INVOICE: {
      entity_type: 'INVOICE',
      permission_entity: [
        Helpers.permissionEntities.INVOICE,
      ],
      key: '/sales/invoices',
      label: 'Invoices',
      // children: {},
      is_premium: !enabledSalesFeatures?.sub_modules?.invoice?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    CONSUMPTION_ORDER: {
      entity_type: 'CONSUMPTION_ORDER',
      permission_entity: [
        Helpers.permissionEntities.CONSUMPTION_ORDER,
      ],
      key: '/sales/consumption',
      label: 'Consumption Order',
      // children: {},
      is_premium: !enabledSalesFeatures?.sub_modules?.consumption_order?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    CREDIT_NOTE: {
      entity_type: 'CREDIT_NOTE',
      permission_entity: [
        Helpers.permissionEntities.CREDIT_NOTE,
      ],
      key: '/sales/credit-notes',
      label: 'Credit Note',
      // children: {},
      is_premium: !enabledSalesFeatures?.sub_modules?.credit_note?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    RETURN_SLIP: {
      entity_type: 'RETURN_SLIP',
      permission_entity: [
        Helpers.permissionEntities.RETURN_SLIP,
      ],
      key: '/sales/return-slips',
      label: 'Return Slip',
      // children: {},
      is_premium: !enabledSalesFeatures?.sub_modules?.return_slip?.is_active,
    },
    E_WAY_BILL: {
      entity_type: 'E_WAY_BILL',
      permission_entity: [
        Helpers.permissionEntities.E_WAY_BILL,
      ],
      key: '/sales/ewaybill',
      label: 'e-Way Bills',
      // children: {},
      is_premium: !enabledSalesFeatures?.addons?.e_waybill?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    TALLY_SYNC: {
      entity_type: 'TALLY_SYNC',
      permission_entity: [],
      addon_permission_check: {
        has_permission: user?.tenant_info?.it_id,
      },
      key: '/integration/tally',
      label: 'Tally Sync',
      // children: {},
      is_premium: false,
      isVisible: {
        onMobile: true,
      },
    },
    OUTGOING_PAYMENT: {
      entity_type: 'OUTGOING_PAYMENT',
      permission_entity: [
        Helpers.permissionEntities.VENDOR_PAYOUT,
      ],
      key: '/purchase/vendor-payouts',
      label: 'Outgoing Payments',
      // children: {},
      is_premium: !enabledPurchaseFeatures?.sub_modules?.payment_outgoing?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    INCOMING_PAYMENTS: {
      entity_type: 'INCOMING_PAYMENTS',
      permission_entity: [
        Helpers.permissionEntities.CUSTOMER_PAYMENTS,
      ],
      key: '/sales/incoming-payments',
      label: 'Incoming Payments',
      // children: {},
      is_premium: !enabledSalesFeatures?.sub_modules?.payment_incoming?.is_active,
      isVisible: {
        onMobile: true,
      },
    },
    REPORTS: {
      entity_type: 'REPORTS',
      permission_entity: [
        Helpers.permissionEntities.REPORTS,
      ],
      key: '/analytics/newReports/v2',
      label: 'Reports',
      // children: {},
      is_premium: false,
      isVisible: {
        onMobile: true,
      },
    },
    BULK_UPLOAD: {
      entity_type: 'BULK_UPLOAD',
      permission_entity: [],
      key: '/analytics/bulkUpload',
      label: 'Bulk Uploads',
      // children: {},
      is_premium: false,
      isVisible: {
        onMobile: true,
      },
    },
    MANAGE_TEAM: {
      entity_type: 'MANAGE_TEAM',
      permission_entity: [
        Helpers.permissionEntities.USER_MANAGEMENT,
        Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
      ],
      key: '/settings/team',
      label: 'Manage Team',
      // children: {},
      is_premium: false,
      isVisible: {
        onMobile: true,
      },
    },
    APPROVALS_SETUP: {
      entity_type: 'APPROVALS_SETUP',
      permission_entity: [
        Helpers.permissionEntities.WORKFLOW_SETUP,
      ],
      key: '/settings/workflow',
      label: 'Approvals Setup',
      // children: {},
      is_premium: !user?.tenant_info?.global_config?.sub_modules?.approval_workflow?.is_active,
      isVisible: {
        onMobile: false,
      },
    },
    BUSINESS_PROFILE: {
      entity_type: 'BUSINESS_PROFILE',
      permission_entity: [
        Helpers.permissionEntities.USER_MANAGEMENT,
      ],
      key: Helpers.getPermission(Helpers.permissionEntities.USER_MANAGEMENT, Helpers.permissionTypes.READ, user)
        ? '/settings/business-profile'
        : '/settings/business-profile?tab=/my-profile',
      label: 'Business Profile',
      // children: {},
      is_premium: false,
      isVisible: {
        onMobile: true,
      },
    },
    WAREHOUSE_SETUP: {
      entity_type: 'WAREHOUSE_SETUP',
      permission_entity: [
        Helpers.permissionEntities.USER_MANAGEMENT,
      ],
      addon_permission_check: {
        has_permission: enabledWarehouseLocations,
      },
      key: '/settings/warehouse-setup',
      label: 'Warehouse Setup',
      // children: {},
      is_premium: !user?.tenant_info?.global_config?.sub_modules?.warehouse_setup?.is_active,
      isVisible: {
        onMobile: false,
      },
    },
  };

  const menu = {
    HOME: {
      entity_type: 'HOME',
      permission_entity: [],
      key: '/',
      label: 'Home',
      children: [],
      prefixIcon: {
        iconLibrary: iconLibrary.FONT_AWESOME_ICON,
        iconName: faHouse,
      },
      seq: 1,
      isVisible: {
        onMobile: true,
      },
    },
    INVENTORY: {
      entity_type: 'INVENTORY',
      permission_entity: [
        Helpers.permissionEntities.PRODUCT,
        Helpers.permissionEntities.INVENTORY_INDENT,
      ],
      key: '/inventory',
      label: 'Inventory',
      children: [
        menuChildren.MANAGE_PRODUCT,
        menuChildren.INVENTORY_TRACKING,
        menuChildren.STOCK_ADJUSTMENT,
        menuChildren.STOCK_TRANSFER,
        menuChildren.DELIVERY_CHALLAN],
      prefixIcon: {
        iconLibrary: iconLibrary.FONT_AWESOME_ICON,
        iconName: faTags,
      },
      seq: 2,
      isVisible: {
        onMobile: true,
      },
    },
    LOGISTICS: {
      entity_type: 'LOGISTICS',
      permission_entity: [
        Helpers.permissionEntities.GATE_DOCUMENT,
      ],
      key: '/logistic',
      label: 'Logistics',
      children: [
        menuChildren.GATE_DOCUMENT,
      ],
      prefixIcon: {
        iconLibrary: iconLibrary.FONT_AWESOME_ICON,
        iconName: faWarehouse,
      },
      seq: 3,
      isVisible: {
        onMobile: true,
      },
    },
    PURCHASE: {
      entity_type: 'PURCHASE',
      permission_entity: [
        Helpers.permissionEntities.VENDORS,
        Helpers.permissionEntities.PURCHASE_REQUEST,
        Helpers.permissionEntities.PURCHASE_ORDER,
        Helpers.permissionEntities.GOOD_RECEIVING,
        Helpers.permissionEntities.PURCHASE_INDENT,
      ],
      key: '/purchase',
      label: 'Purchase',
      children: [
        menuChildren.VENDORS,
        menuChildren.PURCHASE_REQUEST,
        menuChildren.PURCHASE_INDENT,
        menuChildren.REQUEST_FOR_QUOTATION,
        menuChildren.PURCHASE_ORDER,
        menuChildren.GOOD_RECEIVING,
        menuChildren.ACCOUNT_PAYABLE_INVOICE,
        menuChildren.DEBIT_NOTE,
        menuChildren.OUTGOING_PAYMENT,
        menuChildren.EXPENSES,
      ],
      prefixIcon: {
        iconLibrary: iconLibrary.FONT_AWESOME_ICON,
        iconName: faCartShopping,
      },
      seq: 4,
      isVisible: {
        onMobile: true,
      },
    },
    PRODUCTION: {
      entity_type: 'PRODUCTION',
      permission_entity: [
        Helpers.permissionEntities.MO,
        Helpers.permissionEntities.BOM,
        Helpers.permissionEntities.FACTORY_SETUP,
        Helpers.permissionEntities.MRP,
      ],
      key: '/production',
      label: 'Production',
      children: [
        menuChildren.BOM,
        menuChildren.MANUFACTURING_ORDER,
        menuChildren.SCHEDULES,
        menuChildren.MANUAL_ENTRY,
        menuChildren.JOB_CARD,
        menuChildren.MRP,
        menuChildren.FACTORY_SETUP,
      ],
      prefixIcon: {
        iconLibrary: iconLibrary.FONT_AWESOME_ICON,
        iconName: faIndustry,
      },
      seq: 5,
      isVisible: {
        onMobile: true,
      },
    },
    QUALITY_CONTROL: {
      entity_type: 'QUALITY_CONTROL',
      permission_entity: [
        Helpers.permissionEntities.QUALITY_RULES,
        Helpers.permissionEntities.QUALITY_CHECKS,
        Helpers.permissionEntities.IN_PROCESS_QUALITY_CONTROL_RULE,
        Helpers.permissionEntities.IN_PROCESS_QUALITY_CHECK,
      ],
      key: '/quality',
      label: 'Quality Control',
      children: [
        menuChildren.QUALITY_RULES,
        menuChildren.QUALITY_CHECKS,
        menuChildren.IN_PROCESS_QUALITY_CONTROL_RULE,
        menuChildren.IN_PROCESS_QUALITY_CHECK,
        menuChildren.PRE_DISPATCH_INSPECTION_CHECK,
      ],
      prefixIcon: {
        iconLibrary: iconLibrary.FONT_AWESOME_ICON,
        iconName: faFileShield,
      },
      seq: 6,
      isVisible: {
        onMobile: true,
      },
    },
    SALES: {
      entity_type: 'SALES',
      permission_entity: [
        Helpers.permissionEntities.CUSTOMER,
        Helpers.permissionEntities.SALES_ORDER,
        Helpers.permissionEntities.INVOICE,
        Helpers.permissionEntities.CREDIT_NOTE,
        Helpers.permissionEntities.RETURN_SLIP,
      ],
      key: '/sales',
      label: 'Sales',
      children: [
        menuChildren.CUSTOMER,
        menuChildren.ESTIMATE,
        menuChildren.SALES_ORDER,
        menuChildren.PACKING_SLIP,
        menuChildren.INVOICE,
        menuChildren.CONSUMPTION_ORDER,
        menuChildren.CREDIT_NOTE,
        menuChildren.RETURN_SLIP,
        menuChildren.INCOMING_PAYMENTS,
        menuChildren.E_WAY_BILL,
      ],
      prefixIcon: {
        iconLibrary: iconLibrary.FONT_AWESOME_ICON,
        iconName: faBagShopping,
      },
      seq: 7,
      isVisible: {
        onMobile: true,
      },
    },
    ACCOUNTING: {
      entity_type: 'ACCOUNTING',
      permission_entity: [
        Helpers.permissionEntities.VENDOR_PAYOUT,
        Helpers.permissionEntities.CUSTOMER_PAYMENTS,
      ],
      addon_permission_check: {
        condition_type: 'OR',
        has_permission: user?.tenant_info?.it_id,
      },
      key: '/integrations',
      label: 'Accounting',
      children: [
        menuChildren.TALLY_SYNC,
        menuChildren.OUTGOING_PAYMENT,
        menuChildren.INCOMING_PAYMENTS,
      ],
      prefixIcon: {
        iconLibrary: iconLibrary.FONT_AWESOME_ICON,
        iconName: faSackDollar,
      },
      seq: 8,
      isVisible: {
        onMobile: true,
      },
    },
    ANALYTICS: {
      entity_type: 'ANALYTICS',
      permission_entity: [],
      key: '/analytics',
      label: 'Analytics',
      children: [
        menuChildren.REPORTS,
        menuChildren.BULK_UPLOAD,
      ],
      prefixIcon: {
        iconLibrary: iconLibrary.FONT_AWESOME_ICON,
        iconName: faChartPie,
      },
      seq: 9,
      isVisible: {
        onMobile: true,
      },
    },
    SETTINGS: {
      entity_type: 'SETTINGS',
      permission_entity: [
        Helpers.permissionEntities.USER_MANAGEMENT,
        Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
        Helpers.permissionEntities.WORKFLOW_SETUP,
      ],
      key: '/settings',
      label: 'Settings',
      children: [
        menuChildren.MANAGE_TEAM,
        menuChildren.APPROVALS_SETUP,
        menuChildren.BUSINESS_PROFILE,
        menuChildren.WAREHOUSE_SETUP,
      ],
      prefixIcon: {
        iconLibrary: iconLibrary.FONT_AWESOME_ICON,
        iconName: faGear,
      },
      seq: 10,
      isVisible: {
        onMobile: true,
      },
    },
    SWITCH_TO_ADMIN: {
      entity_type: 'SWITCH_TO_ADMIN',
      permission_entity: [],
      key: '/admin/business-units',
      label: 'Switch to Admin',
      children: [],
      prefixIcon: {
        iconLibrary: iconLibrary.FONT_AWESOME_ICON,
        iconName: faBolt,
      },
      seq: 11,
      isVisible: {
        onMobile: false,
      },
    },
  };

  return { menuChildren, menu };
};
